export default "/1.2dd02c39ea876c6110a206ec8b0f9498.png";